import { useState, useEffect } from "react";

export default function VoiceAssistant() {
  const [listening, setListening] = useState(false);
  const [response, setResponse] = useState("Press the button and speak");
  const [recognition, setRecognition] = useState(null);

  useEffect(() => {
    if (typeof window !== "undefined" && (window.SpeechRecognition || window.webkitSpeechRecognition)) {
      const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
      const speechRecognition = new SpeechRecognition();
      speechRecognition.continuous = false;
      speechRecognition.interimResults = false;
      speechRecognition.lang = "en-US";

      speechRecognition.onstart = () => {
        console.log("Speech recognition started.");
      };

      speechRecognition.onresult = async (event) => {
        if (!event?.results || event.results.length === 0) {
          setResponse("No speech detected. Please try again.");
          return;
        }
        const transcript = event.results[0][0].transcript;
        setResponse("Processing...");
        
        try {
          const aiResponse = await fetchResponse(transcript);
          setResponse(aiResponse);
          playTTS(aiResponse);
        } catch (error) {
          console.error("Error fetching AI response:", error);
          setResponse("Error: Unable to process response.");
        }
      };

      speechRecognition.onerror = (event) => {
        const errorMessage = event && typeof event.error === "string" ? event.error : "Unknown error";
        console.error("Speech recognition error:", errorMessage);
        if (errorMessage.includes("not-allowed")) {
          setResponse("Microphone access denied. Please enable permissions.");
        } else {
          setResponse(`Error: ${errorMessage}`);
        }
        setListening(false);
      };
      
      speechRecognition.onend = () => {
        console.log("Speech recognition ended.");
        setListening(false);
      };
      
      setRecognition(speechRecognition);
    } else {
      setResponse("Speech recognition not supported in this browser.");
    }
  }, []);

  const fetchResponse = async (text) => {
    return `You said: ${text}`;
  };

  const playTTS = async (text) => {
    const utterance = new SpeechSynthesisUtterance(text);
    speechSynthesis.speak(utterance);
  };

  const startListening = () => {
    if (recognition) {
      setListening(true);
      setResponse("Listening...");
      try {
        recognition.start();
      } catch (error) {
        console.error("Speech recognition start error:", error);
        setResponse("Error: Unable to start speech recognition.");
        setListening(false);
      }
    }
  };

  return (
    <div className="flex flex-col items-center gap-4 p-6">
      <h1 className="text-xl font-bold">Voice AI Assistant</h1>
      <button onClick={startListening} disabled={listening}>
        {listening ? "Listening..." : "Speak"}
      </button>
      <p className="mt-4 text-lg">{response}</p>
    </div>
  );
}